import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { fluidValues } from '@/css/resources/mixins.css';
import { gridColumnGap, grid } from '@/css/resources/placeholders.css';
import { breakpoints, gridLayout } from '@/css/resources/variables.css';

const getStyles = () =>
	css({
		'--col-gap': '16px',
		'--row-gap': '40px',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		alignItems: 'flex-start',
		alignContent: 'flex-start',
		gap: 'var(--row-gap) var(--col-gap)',

		[`@media (min-width: ${breakpoints.medium})`]: {
			'--col-gap': '36px',
			'--row-gap': '80px',
		},

		'.supt-cardShow': {
			// nbCols / totalCols * (100% - gap * (totalCols - 1)) + gap * (nbCols - 1)

			[`@media (min-width: ${breakpoints.small})`]: {
				flexBasis:
					'calc( (6 / 12) * (100% - var(--col-gap) * 11) + 5 * var(--col-gap))',

				'&.-small': {
					flexBasis:
						'calc( (4 / 12) * (100% - var(--col-gap) * 11) + 3 * var(--col-gap))',
				},
				'&.-large': {
					flexBasis:
						'calc( (7 / 12) * (100% - var(--col-gap) * 11) + 6 * var(--col-gap))',
				},
			},

			[`@media (min-width: ${breakpoints.medium})`]: {
				flexBasis:
					'calc( (5 / 12) * (100% - var(--col-gap) * 11) + 4 * var(--col-gap))',

				'&.-small': {
					flexBasis:
						'calc( (3 / 12) * (100% - var(--col-gap) * 11) + 2 * var(--col-gap))',
				},
				'&.-large': {
					flexBasis:
						'calc( (6 / 12) * (100% - var(--col-gap) * 11) + 5 * var(--col-gap))',
				},
			},

			[`@media (min-width: ${breakpoints.bigLaptop})`]: {
				flexBasis:
					'calc( (4 / 12) * (100% - var(--col-gap) * 11) + 3 * var(--col-gap))',

				'&.-small': {
					flexBasis:
						'calc( (2 / 12) * (100% - var(--col-gap) * 11) + 1 * var(--col-gap))',
				},
				'&.-large': {
					flexBasis:
						'calc( (6 / 12) * (100% - var(--col-gap) * 11) + 5 * var(--col-gap))',
				},
			},
		},
	});

export { getStyles };
